{
  "cookies-dialog": {
    "buttons": {
      "accept-all": "Acceptez tous les cookies",
      "save": "Uložit nastavení",
      "setting": "Nastavení souborů cookie"
    },
    "text": {
      "title": "Ochrana soukromí a soubory cookie",
      "content-1": "Používáme analytické nástroje (např. soubory cookie nebo otisky prstů), abychom zjistili, jak často jsou naše stránky navštěvovány a jak jsou používány. Používáme také technický obsah třetích stran pro zjednodušení kontroly značek (tag manager).",
      "content-2": "V této souvislosti využíváme také poskytovatele služeb ve třetích zemích mimo EU bez odpovídající úrovně ochrany údajů, což s sebou nese následující rizika: Přístup úřadů bez informací, žádná práva subjektů údajů, žádné právní prostředky nápravy, ztráta kontroly.",
      "content-3": "Další informace o používání vašich údajů najdete v našich zásadách ochrany osobních údajů. Svým nastavením vyjadřujete souhlas s výše popsanými postupy.",
      "essential-cookies": "Základní",
      "essential-cookies-description": "Základní soubory cookie umožňují základní funkce a jsou nezbytné pro správnou funkci webových stránek.",
      "statistics-cookies": "Analýza a statistika",
      "statistics-cookies-description": "Soubory cookie pro analýzu a statistiku shromažďují informace anonymně. Tyto informace nám pomáhají pochopit, jak návštěvníci používají naše webové stránky."
    }
  }
}
